import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { createRoot } from "react-dom/client";
import "./assets/scss/material-dashboard-pro-react.scss?v=1.7.0";
import AppRoot from "./AppRoot";
import { decodeHtmlEntitiesPasteValue } from "../../utils/decodeHtmlEntitiesPasteValue.ts";
import { setXsrfToken } from "../../utils/xsrfTokenStore";

axios.defaults.baseURL = "/manager/";

/**
 * Axios opzetten om errors af te vangen
 */

axios.defaults.baseURL = "/manager/";

axios.interceptors.response.use(
  (response) => {
    //Standaard errors afvangen

    const cookieToken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("XSRF-TOKEN=")) // Adjust cookie name if different
      ?.split("=")[1];
    if (cookieToken) {
      setXsrfToken(decodeURIComponent(cookieToken));
    }

    /**
     * Release from app not same as backand response
     */
    if (
      import.meta.env.MODE === "production" &&
      typeof import.meta.env.__RELEASE__ === "string" &&
      typeof response.data.release === "string" &&
      response.data.release !== import.meta.env.__RELEASE__
    ) {
      toast.warn("Please refresh your browser, we have made some improvements", {
        toastId: "needs-refresh",
        position: "top-center",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: false,
        progress: undefined,
      });
    }

    if (response.data.status === "error") {
      toast.error(response.data.message);

      return Promise.reject(response);
    }

    if (response?.data?.forceRedirect != null) {
      return (window.location.href = response.data.forceRedirect);
    }
    if (response?.data?.data?.forceRedirect != null) {
      return (window.location.href = response.data.data.forceRedirect);
    }

    return response;
  },
  (error) => {
    /**
     * Network error afvangen
     */
    if (error.message !== undefined && error.message === "Network Error") {
      toast.error(error.message);
      return Promise.reject(error);
    }

    /**
     * Wel response maar geen goede status code
     */
    if (error.response !== undefined && window.location.pathname !== "/manager/login") {
      const status = error.response.status;

      switch (status) {
        case 419:
          axios
            .get("/manager/keep-alive")
            .then(() => {})
            .catch(() => {
              window.location = "/manager/login";
            });
          break;
        case 401:
          window.location = "/manager/login";
          break;
      }
    }

    return Promise.reject(error);
  }
);

/**
 * Main render functie
 */

const container = document.getElementById("root");
decodeHtmlEntitiesPasteValue(document);
const root = createRoot(container);
root.render(<AppRoot />);
